export class GcpVmInstanceRestoreResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceId",
            "baseName": "instanceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVmInstanceRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
